import { useMemo, useRef, useState } from 'react';
import { CoinWrapper, TreeGameWrapper } from './styled';
import { ReactComponent as CoinIcon } from 'src/assets/icons/bonus-game/coin.svg';
import { ReactComponent as StarIcon } from 'src/assets/icons/bonus-game/star-2.svg';
import { bonusGameApi } from 'src/api/bonus-game';
import styled from 'styled-components';
import treeImagePath from 'src/assets/img/bonus-game/tree.webp';

import coinImagePath from 'src/assets/img/bonus-game/Coin.png';
import { useUserContext } from 'src/pages/BonusGame/contexts/UserContext';

const Image = styled.img`
  width: 6.14vw;
  height: 6.14vw;
`;

const shuffleCoins = (
  coinsLeft: number,
  positions: { top: string; left: string }[],
) => {
  const availablePositions = [...positions];

  const shuffledCoins = [];
  for (let i = 0; i < Number(coinsLeft); i++) {
    const randomCoinPos = Math.floor(Math.random() * availablePositions.length);

    shuffledCoins.push({
      ...availablePositions[randomCoinPos],
      collected: false,
    });

    availablePositions.splice(randomCoinPos, 1);
  }

  while (availablePositions.length) {
    const randomCoinPos = Math.floor(Math.random() * availablePositions.length);

    shuffledCoins.push({
      ...availablePositions[randomCoinPos],
      collected: true,
    });

    availablePositions.splice(randomCoinPos, 1);
  }

  return shuffledCoins;
};

interface TreeGameProps {
  setEndNumber: React.Dispatch<React.SetStateAction<number>>;
  coinsLeft: string;
}

export const TreeGame = ({ setEndNumber, coinsLeft }: TreeGameProps) => {
  const parrentRef = useRef<HTMLDivElement>(null);
  const { selectredTree } = useUserContext();

  const shuffledCoins = useMemo(
    () =>
      shuffleCoins(coinsLeft ? Number(coinsLeft) : 10, selectredTree.positions),
    [selectredTree],
  );

  return (
    <TreeGameWrapper ref={parrentRef} animate={true}>
      <img style={{ width: '100%', height: 'auto' }} src={selectredTree.path} />
      {shuffledCoins.map((pos, idx) => (
        <Coin
          key={idx}
          {...pos}
          parrentRef={parrentRef}
          setEndNumber={setEndNumber}
          coinCollected={pos.collected}
        />
      ))}
    </TreeGameWrapper>
  );
};

interface CoinProps {
  top: string;
  left: string;
  parrentRef: React.RefObject<HTMLDivElement | null>;
  setEndNumber: React.Dispatch<React.SetStateAction<number>>;
  coinCollected: boolean;
}

const Coin = ({
  top,
  left,
  parrentRef,
  setEndNumber,
  coinCollected,
}: CoinProps) => {
  const [animate, setAnimate] = useState(false);
  const [isStarVisible, setIsStarVisible] = useState(coinCollected);
  const coinRef = useRef<HTMLDivElement>(null);

  const distanceToTop = useMemo(() => {
    if (parrentRef.current && coinRef.current) {
      const parentRect = parrentRef.current.getBoundingClientRect();
      const childRect = coinRef.current.getBoundingClientRect();
      return childRect.top - parentRect.top;
    }
    return 0;
  }, [parrentRef, coinRef, animate]);

  const handleCoinClick = async () => {
    const claimRewardsRes = await bonusGameApi.claimRewards();
    setAnimate(true);
    setEndNumber(prev => prev + Number(claimRewardsRes.result.amount));
    setTimeout(() => {
      setAnimate(false);
      setIsStarVisible(true);
    }, 1000);
  };

  return (
    <CoinWrapper
      top={top}
      left={left}
      ref={coinRef}
      animate={animate}
      distanceTopSize={distanceToTop}>
      {isStarVisible ? (
        <StarIcon
          width="6.41vw"
          height="6.41vw"
          style={{
            backgroundColor: 'transparent',
            userSelect: 'none',
            outline: 'none',
          }}
        />
      ) : (
        <Image src={coinImagePath} onClick={handleCoinClick} />
      )}
    </CoinWrapper>
  );
};
